<script>
  import { notifications } from "./utils.svelte";
</script>

{@render notifications()}
